import React, { FC, memo } from "react";

import { LinearGradient } from "../LinearGradient";
import { DEFAULT_SQUARE_SIDE_SIZE } from "../../constants";
import { useSvgDrawParams } from "../../hooks/useSvgDrawParams";
import { SquareProps } from "./types";

export const Square: FC<SquareProps> = memo(
  ({ symbol, width = DEFAULT_SQUARE_SIDE_SIZE, height = DEFAULT_SQUARE_SIDE_SIZE, ...props }) => {
    const { fillId, strokeId, fillColor, fillColors, strokeColor, strokeColors, strokeWidth } =
      useSvgDrawParams(symbol);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        height={height}
        {...props}
      >
        <rect
          rx="2"
          width={width}
          height={height}
          fill={fillColors.length ? `url(#${fillId})` : fillColor}
          stroke={strokeColors.length ? `url(#${strokeId})` : strokeColor}
          strokeWidth={strokeWidth}
        />
        <defs>
          {!!fillColors.length && <LinearGradient id={fillId} colors={fillColors} />}
          {!!strokeColors.length && <LinearGradient id={strokeId} colors={[...strokeColors].reverse()} />}
        </defs>
      </svg>
    );
  },
);
